<template>
<div>
  <div class="container">
    <h1>好兽药用户发布须知</h1>
    <strong>1. 特别提示</strong>
    <strong>1.1</strong>
    <p>好兽药运营方同意按照本协议的规定及其不时发布的操作规则向用户提供好兽药服务。为获得好兽药服务，好兽药服务使用人（以下称"用户"）需在认真阅读及独立思考的基础上认可、同意本协议的全部条款（特别是以加粗方式提示用户注意的条款）并按照页面上的提示完成全部的注册程序。用户在进行发布信息过程中点击"同意" 按钮（或实际使用好兽药服务）即表示用户完全接受本服务协议使用协议、行为规范办法、如用户对本服务协议或协议的任何部分存有任何异议，应终止发布内容程序（或停止使用好兽药服务）。</p>
    <strong>1.2</strong>
    <p>用户注册成功后，好兽药运营方将为用户基于使用好兽药服务的客观需要而在申请、注册好兽药服务时，按照注册要求提供的信息开通好兽药服务，用户有权在好兽药运营方为其开通并同意向其提供服务的基础上使用好兽药服务。同时，用户同意：</p>
    <p>1.2.1 用户应妥善保管好兽药账号及密码。</p>
    <p>1.2.2 用户使用好兽药服务过程中，须对自身使用好兽药服务的行为，对任何由用户通过好兽药服务发布、公开的信息，及对由此产生的任何后果承担全部责任。</p>
    <p>1.2.3 用户可以通过设置功能，自行确认和控制自己在使用好兽药服务过程中提交、发布或显示的信息的公开方式和可见范围。</p>
    <strong>1.3</strong>
    <p>用户使用好兽药服务过程中，对自身使用好兽药服务的行为以及通过好兽药服务发布、公开的任何信息享有合法权利，承担相应法律责任。同时，用户同意：</p>
    <p>1.3.1 好兽药运营方对发布内容（内容即指用户在好兽药上已发布的信息，例如文字、图片、视频、音频等）享有使用权。</p>
    <p>1.3.2 未经好兽药运营方事先书面许可，用户不得自行或授权、协助任何第三方非法抓取好兽药发布的内容，“非法抓取”是指采用程序或者非正常浏览等技术手段获取内容数据的行为。</p>
    <strong>1.4</strong>
    <p>用户在使用好兽药服务过程中应当严格遵守好兽药运营方所发布的用户使用协议。</p>
    <p>未经好兽药运营方事先书面同意，任何用户不得以任何方式自行或委托任何第三方以违反上述规定的方式访问好兽药平台或收集任何好兽药内容。</p>
    <strong>1.5</strong>
    <p>在法律法规允许的范围内，用户同意并授权好兽药运营方就侵犯用户合法权益的行为（包括但不限于私自复制、使用、编辑、抄袭、辱骂、令人反感内容等行为）采取任何形式的法律行动，包括但不限于投诉、诉讼等必要的维权措施。</p>
    <strong>1.6</strong>
    <p>为提高用户的好兽药服务使用感受和满意度，用户同意好兽药运营方可以对用户数据进行调查研究和分析，从而进一步优化好兽药服务。</p>
    <strong>2. 服务内容</strong>
    <strong>2.1</strong>
    <p>好兽药服务的具体内容由好兽药运营方根据实际情况提供，包括但不限于用户使用好兽药服务发布观点、评论、图片、视频、转发链接等，好兽药运营方有权对其提供的服务或产品形态进行升级或其他调整，并将及时更新页面/告知用户。</p>
    <strong>2.2</strong>
    <p>用户理解，好兽药运营方仅提供与好兽药服务相关的技术服务，除此之外与相关网络服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网络而支付的手机费）均由用户自行负担。</p>
    <strong>3. 服务变更、中断或终止</strong>
    <strong>3.1</strong>
    <p>鉴于网络服务的特殊性（包括但不限于服务器的稳定性问题、恶意的网络攻击等行为的存在及其他好兽药运营方无法控制的情形），用户同意好兽药运营方有权随时中断或终止部分或全部的好兽药服务（包括收费网络服务），若发生该等情形，好兽药运营方将尽可能及时通过网页公告、系统通知、私信、短信提醒或其他合理方式通知受到影响的用户。</p>
    <strong>3.2</strong>
    <p>用户理解，好兽药运营方需要定期或不定期地对提供好兽药服务的平台（如互联网网站、应用程序等）或相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，好兽药运营方无需为此承担任何责任，但好兽药运营方应尽可能事先进行通告。</p>
    <strong>3.3</strong>
    <p>如发生下列任何一种情形，好兽药运营方有权随时中断或终止向用户提供本协议项下的好兽药服务（包括收费服务和免费服务）而无需对用户或任何第三方承担任何责任，由此造成的损失由用户自行独立承担：</p>
    <p>3.3.1 用户提供的个人资料不真实；</p>
    <p>3.3.2 用户违反法律法规国家政策或本协议中规定的使用规则；</p>
    <p>3.3.3 用户在使用收费服务时未按规定为其所使用的收费服务支付相关服务费用；</p>
    <p>3.3.4 用户侵犯个人、企业事业单位或社会团体的合法权益，包括但不限于专利权、著作权、商标权，或姓名权、名称权、名誉权、荣誉权、肖像权、隐私权等；</p>
    <p>3.3.5 用户损害监管部门、国家机关及政府形象；</p>
    <p>3.3.6 用户以任何方式损害好兽药运营方及其关联公司的商誉或信誉等合法权益；</p>
    <strong>3.4</strong>
    <p>如用户在申请开通好兽药服务后在任何连续90日内未实际使用，则好兽药运营方有权在法律法规允许的范围内选择采取以下任何一种方式进行处理：</p>
    <p>3.4.1 回收用户昵称；</p>
    <p>3.4.2 回收用户账号；</p>
    <p>3.4.3 停止为该用户提供好兽药服务。</p>
    <p>3.4.4 我们在 24 小时内对令人反感的内容报告采取行动，删除内容并弹出提供违规内容的用户</p>
    <strong>4. 使用规则</strong>
    <strong>4.1</strong>
    <p>用户可自行编辑注册信息中的账号名称、昵称、头像、简介等（以下简称“账号信息”），但应遵守相关法律法规，不得含有违法和不良信息。用户注册好兽药账号，制作、发布、传播信息内容的，应当使用真实身份信息及个人资料，不得以虚假或冒用的居民身份信息、企业相关信息进行注册；若用户的个人资料有任何变动，用户应及时更新。</p>
    <strong>4.2</strong>
    <p>用户知悉并同意，以下信息一经用户提交确认则无法更改，因内容瑕疵（包括但不限于错误，不完整、不满意等）所造成的损失及后果由用户独立承担：</p>
    <strong>4.3</strong>
    <p>好兽药运营方将建立健全用户信息安全管理制度、落实技术安全防控措施。好兽药运营方将对用户使用好兽药服务过程中涉及的用户隐私内容加以保护。</p>
    <strong>4.4</strong>
    <p>为维护好兽药平台的稳定运营，确保用户体验质量，未经好兽药运营方事先书面许可，任何人不得擅自在好兽药平台上实施自动化行为或发布垃圾信息。</p>
    <p>4.4.1 自动化行为，是指未经好兽药运营方同意，用户自行或授权、协助第三方采用自动化手段或明显异于常人的、远高于正常用户频率地发布好兽药、评论、私信、头条文章或作出关注、点赞、抓取数据等的行为。</p>
    <p>4.4.2 垃圾信息，是指未经好兽药运营方同意，擅自使用好兽药账号（包括通过作弊手段批量注册的好兽药账号、普通好兽药账号等）在好兽药、评论、私信、账号信息、头条文章、群聊内容中发布的营销信息、无意义信息或买卖粉丝信息。用户知悉并同意，好兽药运营方有权根据技术规则通过检测验证等方式判断用户账号行为是否构成自动化行为、用户账号所发布的信息是否为垃圾信息，并采取相关措施予以处理。所有处理措施所依据的数据及信息（包括但不限于账号操作记录、好兽药内容、转评赞等）均以好兽药平台后台记录为准。</p>
    <strong>4.5</strong>
    <p>由于好兽药服务的存在前提是用户在申请开通好兽药服务的过程中所提供的账号，用户不应将其账号、密码转让或出借予他人使用。如用户发现其账号或好兽药服务遭他人非法使用，应立即通知好兽药运营方。因黑客行为或用户的保管疏忽等非好兽药运营方原因导致账号、密码及好兽药服务遭他人非法使用的，由用户自行承担相关责任。</p>
    <strong>4.6</strong>
    <p>用户在使用好兽药服务的过程中应文明发言，并依法尊重其它用户的人格权与身份权等人身权利，共同建立和谐、文明、礼貌的网络社交环境。</p>
    <strong>4.7</strong>
    <p>用户在使用好兽药服务过程中，必须遵循以下原则：</p>
    <p>4.7.1 不得违反中华人民共和国法律法规及相关国际条约或规则；</p>
    <p>4.7.2 不得违反与网络服务、好兽药服务有关的网络协议、规定、程序及行业规则；/p>
    <p>4.7.3 不得进行任何可能对互联网或移动网正常运转造成不利影响的行为；</p>
    <p>4.7.4 不得上传、展示或传播任何不实虚假、冒充性的、骚扰性的、中伤性的、攻击性的、辱骂性的、恐吓性的、种族歧视性的、诽谤诋毁、泄露隐私、色情淫秽、恶意抄袭、暴力、血腥、自杀、自残的或其他任何非法的信息资料；</p>
    <p>4.7.5 不得侵犯任何个人、企业事业单位或社会团体的合法权益，包括但不限于专利权、著作权、商标权，或姓名权、名称权、名誉权、荣誉权、肖像权、隐私权等；</p>
    <p>4.7.6 不得以任何方式损害各级国家机关及政府形象；</p>
    <p>4.7.7 不得以任何方式损害好兽药运营方及其关联公司的商誉或信誉等合法权益；</p>
    <p>4.7.8 不得从事其他任何影响好兽药运营方正常运营、破坏好兽药经营模式或其他有害好兽药生态的行为；</p>
    <p>4.7.9 不得为其他任何非法目的而使用好兽药服务。</p>
    <strong>4.8</strong>
    <p>针对某些特定的好兽药服务的使用规则及说明，好兽药运营方通过各种方式（包括但不限于网页公告、系统通知、私信、短信提醒等）作出的任何声明、通知、警示等内容均视为本协议的一部分，用户如使用该等好兽药服务，视为用户同意该等声明、通知、警示的内容。</p>
    <strong>4.9</strong>
    <p>好兽药运营方有权对用户使用好兽药服务的行为及信息进行审查、监督及处理，包括但不限于用户信息（账号信息、个人信息等）、发布内容（位置、文字、图片、音频、视频、商标、专利、出版物等）、用户行为（构建关系、@信息、评论、私信、参与话题、参与活动、营销信息发布、举报投诉等）等范畴。</p>
    <strong>4.10</strong>
    <p>如用户在使用好兽药服务的过程中发现其它用户上传违法侵权等内容，用户可直接点击"举报"按键进行举报，相关人员会尽快核实并进行处理；如涉及姓名权、名称权、名誉权、荣誉权、肖像权、隐私权等人身权益纠纷的处理，用户可依据相关法律法规并参照好兽药有关公告所公示的方式进行处理；如用户认为上述方法无法解决遇到的问题、或用户觉得有必要向司法行政机关寻求帮助的，用户可尽快向相关机关反馈，好兽药运营方将依法配合司法机关的调查取证工作。</p>
    <strong>5. 知识产权</strong>
    <strong>5.1</strong>
    <p>好兽药运营方是好兽药平台和好兽药产品的所有权及知识产权权利人。</p>
    <strong>5.2</strong>
    <p>上述好兽药产品指的是好兽药运营方、好兽药运营方关联公司、或其授权主体等通过好兽药平台为用户提供的包括但不限于信息发布分享、关系链拓展、便捷辅助工具、平台应用程序、公众开放平台等功能、软件、服务等。</p>
    <strong>5.3</strong>
    <p>好兽药运营方是好兽药平台及好兽药产品中所有信息内容的所有权及知识产权权利人。前述信息内容包括但不限于程序代码、界面设计、版面框架、数据资料、账号、文字、图片、图形、图表、音频、视频等，除按照法律法规规定应由相关权利人享有权利的内容以外。</p>
    <strong>5.4</strong>
    <p>鉴于以上，用户理解并同意：</p>
    <p>5.4.1 未经好兽药运营方及相关权利人同意，用户不得对上述功能、软件、服务进行反向工程 （reverse engineer）、反向编译（decompile）或反汇编（disassemble）等；同时，不得将上述内容或资料在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者用于其他任何目的；</p>
    <p>5.4.2 在尽商业上的合理努力的前提下，好兽药运营方并不就上述功能、软件、服务及其所包含内容的延误、不准确、错误、遗漏或由此产生的任何损害，以任何形式向用户或任何第三方承担任何责任；</p>
    <p>5.4.3 好兽药运营方并不对上述任何由第三方提供的功能、软件、服务或内容进行任何保证性的、或连带性的承诺或担保，由此产生的任何纠纷、争议或损害，由用户与第三方自行解决，好兽药运营方不承担任何责任；</p>
    <p>5.4.4 为更好地维护好兽药生态，好兽药运营方保留在任何时间内以任何方式处置上述由好兽药运营方享受所有权及知识产权的产品或内容，包括但不限于修订、屏蔽、删除或其他任何法律法规允许的处置方式。</p>
    <strong>6. 隐私保护</strong>
    <strong>6.1</strong>
    <p>保护用户隐私和其他个人信息是好兽药的一项基本政策，具体内容详见好兽药个人信息相关保护政策。</p>
    <strong>7. 违约责任</strong>
    <strong>7.1</strong>
    <p>如因好兽药运营方违反有关法律、法规或本协议项下的任何条款而给用户造成损失的，因此给用户造成的损害赔偿责任由好兽药运营方承担。</p>
    <strong>7.2</strong>
    <p>用户同意保障和维护好兽药运营方及其关联公司及其他用户的合法权益，如因用户违反有关法律、法规或本协议项下的任何条款而给好兽药运营方及其关联公司或任何其他任何第三方造成损失，用户同意承担由此造成的损害赔偿责任。</p>
    <strong>7.3</strong>
    <p>本协议8.3、8.4中所述的“一切必要措施”包括但不限于以下一项或多项：</p>
    <p>7.3.1 更改、删除或屏蔽相关内容；</p>
    <p>7.3.2 警告违规账号、账号禁言；</p>
    <p>7.3.3 冻结用户账户资金，用于弥补用户给好兽药运营方及其关联公司、他人造成的损失；</p>
    <p>7.3.4 变更、限制或禁止违规账号部分或全部功能；</p>
    <p>7.3.5 暂停、限制或终止用户使用好兽药服务的权利、注销用户账号等；</p>
    <p>7.3.6 向有关监管部门或国家机关报告；</p>
    <p>7.3.7 其他好兽药运营方认为合理的措施。</p>
    <strong>9. 协议修改</strong>
    <strong>9.1</strong>
    <p>好兽药运营方有权随时修改本协议的任何条款，一旦本协议的内容发生变动，好兽药运营方将会在好兽药平台上公布修改之后的协议内容，好兽药运营方也可选择通过其他适当方式（比如系统通知）向用户通知修改内容。</p>
    <strong>9.2</strong>
    <p>如果不同意好兽药运营方对本协议相关条款所做的修改，用户有权停止使用好兽药服务。如果用户继续使用好兽药服务，则视为用户接受好兽药运营方对本协议相关条款所做的修改。</p>
    <strong>10. 通知送达</strong>
    <strong>10.1</strong>
    <p>本协议项下好兽药运营方对于用户所有的通知均可通过网页公告、电子邮件、系统通知、好兽药管理账号主动联系、私信、手机短信或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。</p>
    <strong>10.2</strong>
    <p>用户对于好兽药运营方的通知应当通过好兽药运营方对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。</p>
    <strong>11. 法律适用</strong>
    <strong>11.1</strong>
    <p>本协议的订立、执行和解释及争议的解决均应适用中华人民共和国大陆地区法律。</p>
    <strong>12. 其他规定</strong>
    <strong>12.1</strong>
    <p>如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>
    <strong>12.2</strong>
    <p>本协议中的标题仅为方便而设，在解释本协议时应被忽略，不能作为本协议条款解释的依据。</p>
  </div>
</div>
</template>

<script>
export default {
  name: 'notice',
}
</script>

<style scoped>
  @import '../assets/style/style.css';
</style>